/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

#pupils-area {
  display: flex;
  justify-content: space-between;

  .row {
    margin-top: variables.$margin-large;
    justify-content: space-between;
  }
  & > div {
    flex: 0 0 35%;
    margin: 0 auto;
    max-width: 300px;
  }

  div.label-list {
    padding-top: 32px;
    display: flex;
    flex-direction: column;
    height: 140px;
    justify-content: space-between;
    text-align: center;
  }

  .center-radios label {
    justify-content: center;
    margin: 0;
  }
}

#pupils-size-area {
  div.label-list {
    height: 180px;
  }
}
